export default "__VITE_ASSET__UhLcMwj4__"